<template>
  <svg
    width="240"
    height="240"
    viewBox="0 0 240 240"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M117.589 36.3335C97.7273 36.3335 79.4723 43.2183 65.0581 54.7372H41.7619C38.7353 54.7372 36.2589 57.2217 36.2589 60.2583C36.2589 63.2949 38.7353 65.7794 41.7619 65.7794H53.618H57.0922C60.1189 65.7794 62.5953 68.2639 62.5953 71.3005C62.5953 72.8169 61.9753 74.2009 60.9774 75.1984C59.9832 76.1995 58.6037 76.8216 57.0922 76.8216H49.68H45.5873H25.6197C22.5931 76.8216 20.1167 79.3061 20.1167 82.3427C20.1167 85.3793 22.5931 87.8638 25.6197 87.8638H39.9144C35.5993 98.0381 33.2091 109.233 33.2091 120.99C33.2091 125.256 33.5246 129.449 34.13 133.545C34.3831 135.257 34.6876 136.954 35.0435 138.632C45.4258 137.038 56.4392 135.757 67.9369 134.823L68.8027 135.614L69.6171 134.69C83.4297 133.612 97.9284 133.037 112.882 133.037C144.653 133.037 174.384 135.629 199.804 140.134C200.784 135.872 201.444 131.488 201.756 127.005C201.899 125.017 201.969 123.011 201.969 120.99C201.969 74.234 164.192 36.3335 117.589 36.3335Z"
      fill="#F1F2F7"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.90938 76.5659H5.5744C2.50848 76.5659 0 79.1006 0 82.1985C0 85.2964 2.50848 87.8311 5.5744 87.8311H8.90938C11.9753 87.8311 14.4838 85.2964 14.4838 82.1985C14.4838 79.1006 11.9753 76.5659 8.90938 76.5659Z"
      fill="#F1F2F7"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M199.554 188.413C196.457 188.413 193.922 185.878 193.922 182.78C193.922 179.682 196.457 177.147 199.554 177.147C202.652 177.147 205.187 179.682 205.187 182.78C205.187 185.878 202.652 188.413 199.554 188.413Z"
      fill="#E1E3EF"
    />
    <mask
      id="mask0_17042_1910"
      style="mask-type:luminance"
      maskUnits="userSpaceOnUse"
      x="34"
      y="133"
      width="184"
      height="73"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M217.2 133.159V205.311H126.064H34.9282V133.159H217.2Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_17042_1910)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M217.2 161.055C217.2 164.072 214.724 166.541 211.698 166.541H176.556C175.045 166.541 173.666 167.159 172.672 168.154C171.675 169.145 171.055 170.52 171.055 172.027C171.055 175.045 173.53 177.513 176.556 177.513H183.085C184.596 177.513 185.976 178.132 186.97 179.126C187.967 180.118 188.587 181.493 188.587 183C188.587 186.017 186.111 188.486 183.085 188.486H168.073C153.97 199.049 136.446 205.311 117.454 205.311C76.8915 205.311 43.0157 176.764 34.9282 138.718C45.3081 137.134 56.3188 135.862 67.8137 134.933L68.679 135.719L69.4936 134.801C83.3025 133.729 97.798 133.159 112.748 133.159C144.511 133.159 174.235 135.734 199.649 140.21C198.413 145.543 196.667 150.678 194.467 155.568H211.698C213.213 155.568 214.584 156.186 215.582 157.181C216.58 158.172 217.2 159.548 217.2 161.055Z"
        fill="#E8EBF2"
      />
    </g>
    <mask
      id="mask1_17042_1910"
      style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="32"
      y="35"
      width="170"
      height="170"
    >
      <ellipse
        cx="117.173"
        cy="119.843"
        rx="84.4395"
        ry="84.8435"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask1_17042_1910)">
      <g clip-path="url(#clip0_17042_1910)">
        <path
          d="M97.0608 174.057L112.562 171.025C117.473 170.064 120.676 165.303 119.715 160.391L119.6 159.805C118.639 154.893 113.879 151.69 108.967 152.651L93.466 155.684C88.5543 156.645 85.3515 161.406 86.3125 166.317L86.4273 166.904C87.3882 171.816 92.149 175.018 97.0608 174.057Z"
          fill="white"
        />
        <path
          d="M98.8679 173.69L114.369 170.657C119.28 169.697 122.483 164.936 121.522 160.024L121.407 159.437C120.446 154.526 115.686 151.323 110.774 152.284L95.2732 155.317C90.3614 156.278 87.1587 161.038 88.1197 165.95L88.2344 166.537C89.1954 171.448 93.9562 174.651 98.8679 173.69Z"
          fill="#ADB0CC"
        />
        <path
          d="M119.017 167.854L109.797 168.037L106.138 155.267L116.017 153.901"
          fill="#F1F2F7"
        />
        <path
          d="M114.895 172.196L173.012 164.208C180.745 162.976 185.66 155.267 183.538 147.742C181.66 141.095 174.939 137.058 168.182 138.521L108.833 151.389L114.907 172.196H114.895Z"
          fill="#C8CAE3"
        />
        <path
          d="M109.797 168.037L114.31 165.061C116.456 163.634 117.468 161.012 116.822 158.512C116.09 155.682 113.419 153.78 110.504 154.023L105.089 154.45"
          fill="#7CA9F7"
        />
        <path
          d="M130.457 149.516L146.078 151.767C151.027 152.481 154.468 157.08 153.755 162.029L153.671 162.609C152.958 167.558 148.357 171.011 143.395 170.296L127.774 168.045C122.825 167.332 119.384 162.733 120.097 157.783L120.181 157.204C120.894 152.254 125.493 148.814 130.443 149.527L130.457 149.516Z"
          fill="white"
        />
        <path
          d="M144.255 151.511L128.621 149.258C123.668 148.545 119.073 151.982 118.359 156.935L118.274 157.527C117.56 162.481 120.997 167.075 125.951 167.789L141.584 170.042C146.538 170.755 151.132 167.318 151.846 162.365L151.931 161.773C152.645 156.819 149.208 152.225 144.255 151.511Z"
          fill="#ADB0CC"
        />
        <path
          d="M172.305 126.691L152.351 97.6504C148.668 92.2839 142.569 89.0762 136.056 89.0762H104.089C97.5758 89.0762 91.4775 92.2839 87.7941 97.6504L67.8403 126.691C63.7667 132.618 67.8403 140.717 75.0242 140.985L101.845 141.985L100.881 135.716H139.264L138.3 141.985L165.121 140.985C172.317 140.717 176.378 132.618 172.305 126.691Z"
          fill="white"
        />
        <path
          d="M123.872 95.9061L123.75 95.9915C121.494 97.4185 118.64 97.5039 116.298 96.1988C113.981 94.906 112.554 92.4667 112.554 89.82V81.9653H127.275V89.7346C127.275 92.2349 125.994 94.5645 123.884 95.8939L123.872 95.9061Z"
          fill="white"
        />
        <path
          d="M112.712 76.2455C112.712 77.4286 111.432 79.38 110.395 80.7582C109.761 81.612 108.48 81.612 107.846 80.7582C106.809 79.38 105.528 77.4286 105.528 76.2455C105.528 74.2574 107.138 72.6475 109.126 72.6475C111.114 72.6475 112.724 74.2574 112.724 76.2455H112.712Z"
          fill="#F1F2F7"
        />
        <path
          d="M127.092 76.2455C127.092 77.4286 128.372 79.38 129.409 80.7582C130.043 81.612 131.324 81.612 131.958 80.7582C132.995 79.38 134.276 77.4286 134.276 76.2455C134.276 74.2574 132.666 72.6475 130.678 72.6475C128.69 72.6475 127.08 74.2574 127.08 76.2455H127.092Z"
          fill="#F1F2F7"
        />
        <path
          d="M127.995 78.7334C127.995 84.4414 124.372 89.064 119.908 89.064C115.444 89.064 111.822 84.4414 111.822 78.7334C111.822 78.4895 111.822 78.2455 111.846 78.0016C111.883 77.3186 111.968 76.66 112.102 76.0135C112.127 75.8916 112.151 75.7696 112.188 75.6476C113.212 71.4398 116.286 68.3906 119.908 68.3906C119.957 68.3906 120.006 68.3906 120.042 68.3906C120.359 68.3906 120.677 68.4272 120.994 68.4882C123.677 68.9517 125.946 71.0983 127.129 74.0621C127.287 74.4646 127.434 74.8793 127.543 75.3061C127.775 76.1721 127.934 77.0746 127.982 78.026C127.995 78.2577 127.995 78.4895 127.995 78.7334Z"
          fill="#C7D2EA"
        />
        <path
          d="M130.239 76.5747C130.239 82.2827 125.616 86.9053 119.908 86.9053C114.2 86.9053 109.578 82.2827 109.578 76.5747C109.578 76.3308 109.578 76.0868 109.602 75.8429C109.651 75.1599 109.761 74.5013 109.931 73.8548C109.968 73.7329 110.005 73.6109 110.041 73.4889C111.346 69.2811 115.273 66.2319 119.908 66.2319C119.969 66.2319 120.03 66.2319 120.079 66.2319C120.494 66.2319 120.896 66.2685 121.286 66.3295C124.714 66.793 127.617 68.9396 129.117 71.9034C129.324 72.3059 129.495 72.7206 129.653 73.1474C129.958 74.0134 130.141 74.916 130.214 75.8673C130.227 76.099 130.239 76.3308 130.239 76.5747Z"
          fill="white"
        />
        <path
          d="M122.969 80.1362C123.274 80.1362 123.506 80.4046 123.457 80.7095C123.189 82.4292 121.701 83.7342 119.908 83.7342C118.115 83.7342 116.627 82.4292 116.359 80.7095C116.31 80.4046 116.554 80.1362 116.847 80.1362H122.957H122.969Z"
          fill="#ADB0CC"
        />
        <path
          d="M121.177 165.208L127.787 165.757C129.153 165.866 130.385 164.964 130.69 163.634L132.739 154.853C133.081 153.401 132.117 151.974 130.641 151.73L126.69 151.096"
          fill="#F1F2F7"
        />
        <path
          d="M125.506 169.342L67.0596 164.281C59.2781 163.439 53.9848 155.987 55.7289 148.364C57.2657 141.631 63.7909 137.253 70.5967 138.387L130.519 148.266L125.494 169.354L125.506 169.342Z"
          fill="#C8CAE3"
        />
        <path
          d="M123.726 66.9637C123.726 66.9637 120.359 72.8303 110.273 72.8303V72.7449C110.065 68.5248 113.432 65 117.652 65H120.128C121.579 65 122.933 65.744 123.726 66.9637Z"
          fill="#ADB0CC"
        />
        <path
          d="M122.335 67.3052C122.335 67.3052 123.25 72.3912 129.543 72.8425V69.6591C129.543 67.4027 127.714 65.5732 125.457 65.5732H125.177C123.982 65.5732 122.884 66.2441 122.335 67.293V67.3052Z"
          fill="#ADB0CC"
        />
        <path
          d="M129.544 72.306V74.0257C128.909 74.0257 128.373 73.5623 128.287 72.9402L127.995 70.9888L129.544 72.306Z"
          fill="#ADB0CC"
        />
        <path
          d="M110.261 72.306V74.0257C110.895 74.0257 111.432 73.5623 111.517 72.9402L111.81 70.9888L110.261 72.306Z"
          fill="#ADB0CC"
        />
        <path
          d="M146.424 127.252L158.706 124.349"
          stroke="#D1D1D1"
          stroke-width="0.373333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M93.3802 127.252L81.1104 124.349"
          stroke="#D1D1D1"
          stroke-width="0.373333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M102.016 104.688L90.5752 123.715"
          stroke="#D1D1D1"
          stroke-width="0.373333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M137.801 104.688L149.229 123.715"
          stroke="#D1D1D1"
          stroke-width="0.373333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M150.485 147.815H89.0625V151.12H150.485V147.815Z"
          fill="#ADB0CC"
        />
        <path
          d="M150.485 109.615H89.0625V147.815H150.485V109.615Z"
          fill="#D8DBEA"
        />
        <path
          d="M127.665 154.694L125.982 160.634C125.64 161.841 126.238 163.134 127.384 163.646L131.056 165.317L134.056 153.23L130.385 152.84C129.153 152.706 127.994 153.487 127.665 154.682V154.694Z"
          fill="#ADB0CC"
        />
        <path
          d="M124.202 130.472C124.202 133.057 122.104 135.155 119.518 135.155C116.932 135.155 114.834 133.057 114.834 130.472C114.834 127.886 116.932 125.788 119.518 125.788C122.104 125.788 124.202 127.886 124.202 130.472Z"
          fill="white"
        />
      </g>
      <path
        d="M141 76.65C156.13 78.04 157.26 79.17 158.65 94.3C160.04 79.17 161.17 78.04 176.3 76.65C161.17 75.26 160.04 74.13 158.65 59C157.26 74.13 156.13 75.26 141 76.65Z"
        fill="white"
      />
      <path
        d="M56 96.64C65.98 97.56 66.72 98.3 67.64 108.28C68.56 98.3 69.3 97.56 79.28 96.64C69.3 95.72 68.56 94.98 67.64 85C66.72 94.98 65.98 95.72 56 96.64Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_17042_1910">
        <rect
          width="128.626"
          height="109.221"
          fill="white"
          transform="translate(55.3999 65)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
